/** Invitations carry a destination, never an authenticated session. */
export type AppInvitation = { kind: 'crew' | 'company'; code: string };

export function parseInvitationStartParam(value: string | null | undefined): AppInvitation | null {
  const crew = /^join_([a-z0-9_-]{4,64})$/i.exec(value || '');
  if (crew) return { kind: 'crew', code: crew[1].toUpperCase() };
  const company = /^empinvite_([a-f0-9]{20,64})$/i.exec(value || '');
  return company ? { kind: 'company', code: company[1].toLowerCase() } : null;
}

export function invitationStartParam(invite: AppInvitation): string {
  return `${invite.kind === 'crew' ? 'join' : 'empinvite'}_${invite.code}`;
}

export function invitationLinks(invite: AppInvitation) {
  const start = encodeURIComponent(invitationStartParam(invite));
  const browser = `https://ziawellnav.com/?startapp=${start}`;
  return {
    browser,
    telegram: `https://t.me/ZiaWellNavBot/app?startapp=${start}`,
    // HTTPS remains clickable in email clients that strip custom schemes.
    apple: `${browser}&openInvite=apple`,
    native: `com.ziawellnav.app://invite?startapp=${start}`,
  };
}

export function buildCrewInviteLink(inviteCode: string): string {
  return invitationLinks({ kind: 'crew', code: inviteCode.trim().toUpperCase() }).browser;
}

export function buildCrewInviteMessage(crewName: string, inviteCode: string, recipient = ''): string {
  const links = invitationLinks({ kind: 'crew', code: inviteCode.trim().toUpperCase() });
  const greeting = recipient.trim().replace(/^@/, '');
  return `${greeting ? `${greeting}, ` : ''}join ${crewName} on ZiaWellNav.\n\nOpen in browser: ${links.browser}\n\nOpen in Telegram: ${links.telegram}\n\nOpen in Apple app: ${links.apple}\n\nSign in with your email, then accept the invitation.`;
}
